/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EListSearchType } from './EListSearchType';
import {
    EListSearchTypeFromJSON,
    EListSearchTypeFromJSONTyped,
    EListSearchTypeToJSON,
} from './EListSearchType';
import type { ESearchCctType } from './ESearchCctType';
import {
    ESearchCctTypeFromJSON,
    ESearchCctTypeFromJSONTyped,
    ESearchCctTypeToJSON,
} from './ESearchCctType';

/**
 * 
 * @export
 * @interface EListSearchTypeESearchCctTypeCombinableCriteria
 */
export interface EListSearchTypeESearchCctTypeCombinableCriteria {
    /**
     * 
     * @type {EListSearchType}
     * @memberof EListSearchTypeESearchCctTypeCombinableCriteria
     */
    searchMode?: EListSearchType;
    /**
     * 
     * @type {ESearchCctType}
     * @memberof EListSearchTypeESearchCctTypeCombinableCriteria
     */
    value?: ESearchCctType;
    /**
     * 
     * @type {ESearchCctType}
     * @memberof EListSearchTypeESearchCctTypeCombinableCriteria
     */
    secondaryValue?: ESearchCctType;
}

/**
 * Check if a given object implements the EListSearchTypeESearchCctTypeCombinableCriteria interface.
 */
export function instanceOfEListSearchTypeESearchCctTypeCombinableCriteria(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EListSearchTypeESearchCctTypeCombinableCriteriaFromJSON(json: any): EListSearchTypeESearchCctTypeCombinableCriteria {
    return EListSearchTypeESearchCctTypeCombinableCriteriaFromJSONTyped(json, false);
}

export function EListSearchTypeESearchCctTypeCombinableCriteriaFromJSONTyped(json: any, ignoreDiscriminator: boolean): EListSearchTypeESearchCctTypeCombinableCriteria {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'searchMode': !exists(json, 'searchMode') ? undefined : EListSearchTypeFromJSON(json['searchMode']),
        'value': !exists(json, 'value') ? undefined : ESearchCctTypeFromJSON(json['value']),
        'secondaryValue': !exists(json, 'secondaryValue') ? undefined : ESearchCctTypeFromJSON(json['secondaryValue']),
    };
}

export function EListSearchTypeESearchCctTypeCombinableCriteriaToJSON(value?: EListSearchTypeESearchCctTypeCombinableCriteria | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'searchMode': EListSearchTypeToJSON(value.searchMode),
        'value': ESearchCctTypeToJSON(value.value),
        'secondaryValue': ESearchCctTypeToJSON(value.secondaryValue),
    };
}

